import { Button, Flex, Input } from "@chakra-ui/react";
import {
	forwardRef,
	useCallback,
	useImperativeHandle,
	useRef,
	useState,
} from "react";
import PaperclipIcon from "./icons/PaperclipIcon";

export type TemporaryFile = {
	id?: number;
	name: string;
};

interface FileInputButtonProps {
	name: string;
	display?: string;
	maxNumberOfFiles?: number;
	files?: File[] | TemporaryFile[];
	onFileChange?: (files: File[] | null) => void;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
	accept?: string;
}

const FileInputButton = forwardRef<HTMLInputElement, FileInputButtonProps>(
	(
		{
			name,
			maxNumberOfFiles,
			files: defaultFiles,
			onFileChange,
			onChange,
			onBlur,
			display,
			accept,
		},
		ref,
	) => {
		const [files, setFiles] = useState<File[] | TemporaryFile[]>(
			defaultFiles ?? [],
		);
		const inputRef = useRef<HTMLInputElement>(null);
		useImperativeHandle(ref, () => inputRef.current!, []);

		const handleOnInput = useCallback(() => {
			if (onFileChange) {
				if (inputRef.current?.files) {
					const currentFiles = Array.from(inputRef.current.files).slice(
						0,
						maxNumberOfFiles ?? Number.POSITIVE_INFINITY,
					);
					if (currentFiles.length === 0 && files.length !== 0) {
						return;
					}
					onFileChange(currentFiles);
					setFiles(currentFiles);
				}
			}
		}, [onFileChange, maxNumberOfFiles, files.length]);

		return (
			<Flex
				display={display}
				w={"fit-content"}
				onClick={() => {
					if (inputRef.current) {
						inputRef.current.click();
					}
				}}
			>
				<Input
					ref={inputRef}
					type="file"
					name={name}
					display={"none"}
					onInput={handleOnInput}
					onChange={onChange}
					onBlur={onBlur}
					accept={accept}
					multiple={maxNumberOfFiles ? maxNumberOfFiles > 1 : false}
				></Input>
				<Button variant="outline" w="100%">
					<PaperclipIcon mr={2} />
					Joindre un ou des fichiers
				</Button>
			</Flex>
		);
	},
);

export default FileInputButton;
